const exercise = {
  exercise: "Exercice",
  create: "Créer un exercice",
  edit: "Modifier un exercice",
  createExerciseInstruction:
    'Entrez la question, sélectionnez dans le texte la ou les partie(s) qui correspondent à la réponse et cliquez sur le bouton "Réponse" pour valider. Veuillez entrer le nombre de questions correspondant au barème sélectionné.',
  exercises: "Exercices",
  doExercises: "Faire des exercices d'entraînement",
};

export default exercise;
